import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './filters'

// Bootstrap-vu stuff
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.use(VueLodash, {name: 'custom', lodash: lodash})

// Font awesome stuff
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faFileAlt,
  faPlus,
  faMinus,
  faCheckSquare,
  faBookOpen,
  faChartBar,
  faTrash,
  faMinusSquare,
  faFileExport,
  faTrain,
  faListAlt,
  faHardHat,
  faUnlock,
  faEdit,
  faBuilding,
  faLandmark,
  faUsers,
  faIdCardAlt,
  faUserPlus,
  faUserCircle,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faQuestionCircle,
  faHome,
  faInfoCircle,
  faChartPie,
  faClipboardList,
  faAngleDoubleDown,
  faDownload,
  faUserShield,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add([faDownload, faUserShield, faFileAlt, faIdCardAlt, faFileExport, faPlus, faChartBar, faBookOpen, faTimes, faMinus, faCheckSquare, faListAlt, faTrain, faTrash, faHardHat, faUnlock, faEdit, faBuilding, faLandmark, faUserCircle, faAngleDoubleLeft, faAngleDoubleRight, faQuestionCircle, faHome, faUsers, faUserPlus, faInfoCircle, faChartPie, faClipboardList, faMinusSquare, faAngleDoubleDown])
Vue.component('Icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// Main css file
import './assets/style/_main.scss'

// Initialize the user store to check the authentication
import SessionStore from '@/stores/SessionStore'

import axios from "axios";
import {EventBus} from '@/event-bus'

axios.interceptors.request.use(function (config) {
  EventBus.$emit('Axios-loading', true);
  return config;
}, function (error) {
  EventBus.$emit('Axios-loading', false);
  return Promise.reject(error);
});

axios.interceptors.response.use(function (config) {
  EventBus.$emit('Axios-loading', false);
  return config;
}, function (error) {
  EventBus.$emit('Axios-loading', false);
  return Promise.reject(error);
});

SessionStore.init().then(() =>
    new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
);